import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { PickupService } from '@checkout/feature';
import { EnvironmentService } from '@core/feature';
import { TodayTomorrowDatePipe } from '@sdvor/shared/ui';
import { ShopWorkingTimeService } from '@shop/feature';
import { ShopListDesktopComponent } from '@shop/ui';
import { CxDatePipe } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { GeocodeService } from '@yandex-maps/feature';

@Component({
  selector: 'sd-pickup-shop-list-desktop',
  templateUrl: './pickup-shop-list-desktop.component.html',
  styleUrls: ['./pickup-shop-list-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TodayTomorrowDatePipe, CxDatePipe],
  standalone: false,
})
export class SdvorPickupShopListDesktopComponent extends ShopListDesktopComponent {
  constructor(
    modalService: ModalService,
    datePipe: TodayTomorrowDatePipe,
    shopWorkingTimeService: ShopWorkingTimeService,
    cdRef: ChangeDetectorRef,
    geocodeService: GeocodeService,
    environmentService: EnvironmentService,
    private pickupService: PickupService,
  ) {
    super(modalService, datePipe, shopWorkingTimeService, cdRef, geocodeService, environmentService);
  }

  clickToListShop(id: string, zoom: number = 14): void {
    this.activeId$.next(id);
    this.mapInstance.setZoom(zoom);
    this.selectShopMap(id, false);
  }

  confirmShop(id: string): void {
    this.setShopId.emit(id);
    this.pickupService.setShop(id);
    this.modalService.closeActiveModal();
    this.setShop(id);
  }
}
